import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
  const decryptedData = CryptoJS.AES.decrypt(localStorage.getItem("token"), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);
  return decryptedData;
};

export const getGlobalSettingsAction = () => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .get("/api/setting", {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateGlobalSettingAction = (data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  return new Promise((resolve, reject) => {
    axios
      .put(`/api/setting`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getCountryAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/setting/country")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

export const getStateAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/setting/state", data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

//below is pending
export const getCurrencyConvertationRateAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/setting/currencyConvertationRate")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

export const getPublicSettingsAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/setting/public")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
};

export const getAdminEmailAction = () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/setting/email-admin")
      .then((response) => {
        resolve(response.data.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};